<template>
  <div class="item-content">
    <img
      class="title-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/3e1a4ca185c9e1b1b3a78aa91e9ad3d3_wh=807_252.webp"
      alt=""
    />
    <div class="top-item">
      <div class="item-padding">
        <!-- <div class="toggle-open iconfont icon-black" :class="{ 'open-roate': isOpen }" @click="bindToggleOpen">
            </div> -->
        <div class="task-container">
          <div class="desc">*完成以下任一打卡，即算打卡成功</div>
          <div class="task-list" v-if="data && data.length">
            <div
              class="task-item"
              v-for="(item1, index1) in data"
              :key="index1"
            >
              <img :src="item1.icon" class="item-icon" alt="" />
              <div class="item-center">
                <div
                  ><span class="item-title">{{ item1.name }}</span>
                </div>
                <div class="item-desc">{{ item1.notice }}</div>
              </div>
              <div
                class="item-btn"
                :class="{
                  'item-btn-confirm':
                    item1.plan_state || [1, 2].includes(status)
                }"
                @click="bindClickItem(item1)"
                v-clickBuried
                :data-click-buried="'CLICK_VIP_HD_0YDK_DK_' + (activityId + 1)"
                >{{ getBtnText(item1) }}</div
              >
            </div>
          </div>
          <div v-else class="not-task">暂无任务</div>
        </div>
      </div>
    </div>
    <img
      v-if="type == 1"
      class="image1"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/ff642c94f42b7bb63f917ac5906dbd7e_wh=1041_1005.webp"
      alt=""
    />
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 1
    },
    status: {
      type: Number,
      default: 0
    },
    activityId: {
      type: Number,
      default: 2
    }
  },
  filters: {},
  computed: {},
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    bindToggleOpen() {
      this.isOpen = !this.isOpen
    },
    bindClickItem(item) {
      this.$emit('task', item)
    },
    getBtnText(item) {
      if (this.status == 1) {
        return '挑战成功'
      } else if (this.status == 2) {
        return '挑战失败'
      } else {
        return item.plan_state ? '已完成' : item.button_content
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.item-content {
  padding: 0px 14px;
  margin-bottom: 23px;
}
.image1 {
  margin-top: -14px;
  width: 100%;
}
.title-image {
  margin: 0 auto;
  width: 269px;
  height: 84px;
  object-fit: contain;
  position: relative;
  z-index: 1;
}
.top-item {
  margin-top: -23px;
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  .item-padding {
    border-radius: 0px 0px 16px 16px;
    padding: 34px 16px 30px;

    .toggle-open {
      transition: transform 0.3s ease;
      position: absolute;
      left: 50%;
      bottom: 10px;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translate(-50%, 0%) rotate(0deg);
      color: rgba(0, 0, 0, 0.3);
      font-size: 20px;
      transform-origin: center center;
    }

    .open-roate {
      transform: translate(-50%, 0%) rotate(180deg);
    }
  }

  .task-container {
    overflow: hidden;
    padding-top: 2px;

    .desc {
      text-align: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
      line-height: 18px;
      margin-bottom: 26px;
    }

    .task-info {
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: 18px;
      margin-bottom: 26px;

      .red {
        color: #00b6ff;
      }
    }

    .task-list {
      .task-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .item-icon {
          width: 44px;
          height: 44px;
          object-fit: contain;
          margin-right: 10px;
        }

        .item-center {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          margin-right: 10px;
        }

        .item-title {
          font-size: 15px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 24px;
          margin-right: 5px;
        }

        .item-num-icon {
          display: inline-block;
          width: 11px;
          height: 11px;
          object-fit: contain;
          margin-right: 3px;
        }

        .item-num {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #00b6ff;
          line-height: 22px;
        }

        .item-desc {
          font-size: 11px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 18px;
        }

        .item-btn {
          width: 66px;
          height: 28px;
          background: #00b6ff;
          border-radius: 15px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 28px;
          text-align: center;
        }

        .item-btn-confirm {
          background-color: rgba(0, 182, 255, 0.1);
          color: #00b6ff;
        }
      }

      .task-item:last-child {
        margin-bottom: 0;
      }
    }
    .not-task {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      height: 235px;
      color: rgba(0, 0, 0, 0.5);
    }
  }

  .task-container-limit {
    max-height: 494px;
  }
}
</style>
